import * as t from 'io-ts'

export const Treatment = t.union([t.literal('C'), t.literal('T1'), t.literal('T2'), t.literal('T3')])
export type Treatment = t.TypeOf<typeof Treatment>

export const WeblabTreatment = t.type(
  {
    weblab: t.string,
    treatment: Treatment,
  },
  'WeblabTreatment',
)
export type WeblabTreatment = t.TypeOf<typeof WeblabTreatment>

export const WeblabCacheEntry = t.intersection(
  [
    t.type({
      principal: t.string,
    }),
    WeblabTreatment,
  ],
  'WeblabtCacheEntry',
)

export type WeblabCacheEntry = t.TypeOf<typeof WeblabCacheEntry>
